// extracted by mini-css-extract-plugin
export default {"like":"like_like__N1j5z","liked":"like_liked__LBVRr"};